import React from 'react';
import { Popover, PopoverOrigin, PopoverReference, makeStyles, Menu } from '@material-ui/core';

interface ClickPopoverProps {
    popoverId: string,
    openPopover: boolean,
    // It's used to set the position of the popover.
    anchorEl?: HTMLElement | null | undefined,
    // This is the point on the anchor where the popover's anchorEl will attach to.
    anchorOrigin?: PopoverOrigin | { horizontal: 'center', vertical: 'center' },
    // This determines which anchor prop to refer to when setting the position of the popover.
    anchorReference?: PopoverReference,
    // This is the point on the popover which will attach to the anchor's origin.
    transformOrigin?: PopoverOrigin | { horizontal: 'center', vertical: 'center' },
    popoverStyles: object,
    handleClose: (e: React.MouseEvent<HTMLDivElement>) => void,
    message?: any,
}

const ClickPopover = function ({
    popoverId, openPopover, anchorEl, handleClose, message, anchorOrigin,
    transformOrigin, anchorReference, popoverStyles = {},
}: ClickPopoverProps) {

    const styles = makeStyles(() => ({ popoverRoot: { ...popoverStyles } }));
    const classes = styles() ?? { popoverRoot: '' };

    return (
        <Popover
            id={popoverId}
            open={openPopover}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorReference={anchorReference}
            transformOrigin={transformOrigin}
            anchorOrigin={anchorOrigin}
            classes={{
                root: classes.popoverRoot,
            }}
            disableScrollLock={true}
        >
            {message}
        </Popover>
    );
};

export default ClickPopover;
